import AssetClasses from './assetClasses'

export default AssetClasses
